import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App.tsx';
import { AuthProvider } from './context/AuthContext.tsx';
import { ErrorProvider } from './context/ErrorContext.tsx';
import { ErrorBoundary } from './shared/components/ErrorBoundary.tsx';
import { reloadForFreshChunks } from './utils/chunkErrorRecovery';
import './index.css';

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 30_000, gcTime: 5 * 60_000 } },
});

// A lazy route's chunk (src/App.tsx) can 404 after a new deploy replaces its
// hashed filename while this tab still has the old index.html — reload once
// to pick up the fresh build instead of leaving the user on a broken route.
window.addEventListener('vite:preloadError', () => {
  reloadForFreshChunks();
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
      <Router>
        <ErrorProvider>
          <AuthProvider>
            <App />
          </AuthProvider>
        </ErrorProvider>
      </Router>
      </QueryClientProvider>
    </ErrorBoundary>
  </StrictMode>,
);
